const toggleClass = () => {
 const DATA_TARGET = `toggle-class`;
 const DATA_TOGGLE_CONTENT = `toggle-content`;

 const CLASS_SELECTOR = `.test-toggle, .js-toggle-class, .nav-depth-2 > li:has(.depth-wrap) > a`;
 const CLASS_ACTIVE = `active`;

 const getAriaAttrName = (element) =>
 element.matches(`[aria-controls]`) ||
 element.matches(`[data-${DATA_TOGGLE_CONTENT}]`)
 ? `aria-expanded`
 : `aria-pressed`;

 const getControlledElement = (element) => {
 const controlsId = element.getAttribute(`aria-controls`);

 if (controlsId) return document.getElementById(controlsId);

 return null;
 };

 const getToggleClassNames = (element) => {
 const classAttr = element.getAttribute(`data-${DATA_TARGET}`);

 return classAttr ? classAttr.split(` `) : [CLASS_ACTIVE];
 };

 const setToggleElement = (element) => {
 const ariaAttrName = getAriaAttrName(element);
 const isActive = getToggleClassNames(element).some((className) =>
 element.matches(`[class~=${className}]`),
 );
 const controlledEl = getControlledElement(element);

 element.setAttribute(ariaAttrName, isActive);
 controlledEl && controlledEl.setAttribute(`aria-hidden`, !isActive);

 if (element.matches(`a:not([role])`)) {
 element.setAttribute(`role`, `button`);

 if (element.matches(`a:not([data-origin-href])`)) {
 const originHref = element.getAttribute(`href`) ?? ``;
 const controlsId = element.getAttribute(`aria-controls`);

 element.setAttribute(`data-origin-href`, originHref);

 const newHref =
 originHref.startsWith(`#`) && originHref.length > 1
 ? originHref
 : controlsId
 ? `#${controlsId}`
 : `#`;

 element.setAttribute(`href`, newHref);
 }
 }
 };

 const updateState = (toggleTarget, classNames) => {
 const ariaAttrName = getAriaAttrName(toggleTarget);
 const isActive = toggleTarget.matches(`[${ariaAttrName}="true"]`);
 const controlledEl = getControlledElement(toggleTarget);

 classNames.forEach((className) => {
 toggleTarget.classList[isActive ? `remove` : `add`](className);
 });

 toggleTarget.setAttribute(ariaAttrName, !isActive);
 controlledEl && controlledEl.setAttribute(`aria-hidden`, isActive);
 };

 const handleToggle = (event) => {
 const { target, key, type, repeat } = event;
 const toggleTarget =
 target.closest(`[data-${DATA_TARGET}]`) || target.closest(CLASS_SELECTOR);

 if (
 !toggleTarget ||
 (type !== `click` && type !== `keydown`) ||
 (type === `keydown` &&
 (repeat ||
 (key !== ` ` && key !== `Enter`) ||
 toggleTarget.matches(`button`)))
 )
 return;

 if (type === `keydown` && toggleTarget.matches(`a`)) {
 if (key === ` `) {
 event.preventDefault();
 toggleTarget.click();
 }

 return;
 }

 toggleTarget.matches(`a`) && event.preventDefault();
 updateState(toggleTarget, getToggleClassNames(toggleTarget));
 };

 const applyToggleState = () => {
 const toggleElements = document.querySelectorAll(`
 [data-${DATA_TARGET}],
 ${CLASS_SELECTOR}
 `);

 toggleElements.forEach(setToggleElement);
 };

 const initialize = () => {
 applyToggleState();

 document.body.addEventListener(`click`, handleToggle);
 document.body.addEventListener(`keydown`, handleToggle);
 };

 initialize();

 toggleClass.update = applyToggleState;

 toggleClass.cleanup = (targets) => {
 if (!targets) {
 document.body.removeEventListener(`click`, handleToggle);
 document.body.removeEventListener(`keydown`, handleToggle);

 return;
 }

 const toggleElements = document.querySelectorAll(`${targets}`);

 if (!toggleElements.length) return;

 toggleElements.forEach((element) => {
 const controlledEl = getControlledElement(element);

 element.matches(`a[aria-pressed][role], a[aria-expanded][role]`) &&
 element.removeAttribute(`role`);
 element.removeAttribute(`aria-pressed`);
 element.removeAttribute(`aria-expanded`);

 if (element.matches(`a[data-origin-href]`)) {
 element.setAttribute(`href`, element.getAttribute(`data-origin-href`));
 element.removeAttribute(`data-origin-href`);
 }

 controlledEl && controlledEl.removeAttribute(`aria-hidden`);
 });
 };
};

export default toggleClass;
